import Home from '../home';
import { groups } from '../utils/constants';

const CloudFree = () => {
  return (
    <Home
      title={'Cloudfree Applications'}
      subTitle={'Binaries'}
      homeUrl={'/cloudfree'}
      group={groups.CLOUDFREE}
    />
  );
};

export default CloudFree;
